'use client';

import { useEffect } from 'react';

import { scrollToElementId } from '@/lib/ui/scroll-to-id';

/** Applies header-aware scroll when the landing loads with a section hash. */
export function LandingHashScroll(): null {
  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (id.length === 0) {
      return;
    }

    // Wait for header chrome measurement and section layout before centering.
    const frame = window.requestAnimationFrame(() => {
      scrollToElementId(id);
    });

    return (): void => {
      window.cancelAnimationFrame(frame);
    };
  }, []);

  return null;
}
